export default "/_next/static/chunks/fonts/TheinhardtMedium-41f9cf98c167e34abbeafb8074e6f8e2.woff";